export default __webpack_public_path__ + "static/media/popover-position-right.fc58b0de.svg";